import React from "react";
import { Link } from "react-router-dom";

import { ContractTemplate } from "../../hooks/useInsertContractTemplate";
import useTranslations from "../../hooks/useTranslations";
import { H5, Span } from "../wombat-ui";

type ContractTemplateCardProps = {
  contract?: ContractTemplate;
};

const ContractTemplateCard: React.FC<ContractTemplateCardProps> = ({
  contract,
}) => {
  const t = useTranslations();

  return (
    <Link to={`/contracts/templates/edit/${contract.id}`} role="button">
      <div
        tabIndex={0}
        role="button"
        className="flex flex-col flex-grow h-full max-w-md p-1 px-6 py-3 rounded-lg shadow-md focus:outline-none ring-4 ring-white bg-light-0 hover:shadow-lg focus:shadow-lg"
      >
        <H5 className="flex items-center justify-between">{contract.title}</H5>
        <Span className="pt-1 text-xs text-light-900">
          {contract?.description
            ? contract.description
            : t("contracts.noDescription")}
        </Span>
      </div>
    </Link>
  );
};

export default React.memo(ContractTemplateCard);
